import React from 'react'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CopyToClipboard from 'react-copy-to-clipboard'
import {
  Divider,
  Grid,
  FormLabel,
  FormControl,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material'
import Stack from '@mui/material/Stack'

const WorkflowFlyoutNotes = ({
  title = 'Add Note',
  value = '',
  onChange = () => {},
  onClear = () => {},
  onApply = () => {},
  isLoading = false,
  isDisabled = false,
  notesAction = '',
  reusedWarning = () => <></>,
  failedFiles = [],
  tabWiseSelection = [],
  classes = {},
}) => {
  const renderFailureList = () => {
    const failedFilesList = failedFiles?.join(', ') || ''
    return (
      <div style={{ marginTop: '34px' }}>
        <Grid container spacing={2} alignItems={'end'}>
          <Grid item>
            <ErrorOutlineIcon className={classes.errorOutlineIconCls} />
          </Grid>
          <Grid item>
            <Typography
              color="error"
              component={'subtitle2'}
              sx={{ fontWeight: 'bold', color: '#B85300' }}
            >
              Failed TCINs: {failedFilesList}
            </Typography>
          </Grid>
          <Grid>
            <CopyToClipboard text={failedFilesList}>
              <Button
                className={classes.copyButtonCls}
                startIcon={<ContentCopyIcon />}
              >
                Copy To Clipboard
              </Button>
            </CopyToClipboard>
          </Grid>
        </Grid>
      </div>
    )
  }
  return (
    <>
      <Divider className={classes.drawerHeaderDivider} />
      {reusedWarning()}
      {!isLoading && failedFiles?.length > 0 && renderFailureList()}
      <Grid container className={classes.drawerContainer}>
        <Grid item xs={9} lg={9} md={9}>
          <FormLabel className={classes.tagsLabel}>
            For {tabWiseSelection.length} selected images
          </FormLabel>
          <FormControl variant="outlined" fullWidth>
            <TextField
              value={value}
              onChange={onChange}
              label={title}
              multiline
              rows={10}
              variant="outlined"
            />
          </FormControl>
          <Grid>
            <Stack direction="row" className={classes.buttonGroup} spacing={2}>
              <Button
                variant="outlined"
                className={classes.stausButton}
                onClick={onClear}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                className={`${classes.stausButton} ${classes.primaryButton}`}
                disabled={isDisabled}
                onClick={onApply}
              >
                {isLoading && notesAction === 'add' ? (
                  <CircularProgress size={14} />
                ) : (
                  'Apply'
                )}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default WorkflowFlyoutNotes
